import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
import _Object$assign from "@babel/runtime-corejs3/core-js-stable/object/assign";
import _flatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/flat";
import { h as _h, isVue3 } from 'vue-demi';
import { patchComponent, useListeners, passListeners } from '../_use';
import { generate } from './regenerate';
const iconType = {
  name: String,
  size: {
    type: String,
    default: '20px'
  },
  theme: {
    type: String,
    default: 'light'
  }
};
const UiIcon = patchComponent({
  name: 'UiIcon',
  mixins: [],
  props: iconType,
  emits: {
    click: e => true
  },
  computed: {
    icon() {
      const icon = this.$options.icons.find(i => {
        const name = this.theme === 'dark' ? "dark:".concat(this.name) : this.name;
        return String(i.name).toLocaleLowerCase() === String(name).toLocaleLowerCase();
      });
      if (icon) {
        return icon;
      } else {
        return undefined;
      }
    }
  },
  methods: {
    handleClick(evt) {
      this.$emit('click', evt);
    }
  },
  render(h) {
    if (isVue3) {
      h = _h;
    }
    if (!this.icon) return null;
    const listeners = _Object$assign({}, useListeners(this), {
      click: this.handleClick
    });
    if (this.icon.type === 'png') {
      const size = this.size.replace('px', '');
      return h("img", _mergeJSXProps([{
        "attrs": {
          "src": this.icon.icon.src,
          "width": size,
          "height": size
        }
      }, passListeners(listeners)]));
    } else {
      return generate(this.icon.icon, "svg-".concat(this.icon.name), {
        attrs: {
          'data-icon': this.icon.name,
          width: this.size,
          height: this.size,
          fill: 'currentColor'
        },
        listeners: listeners
      }, h);
    }
  }
});
const withCustomMethod = function withCustomMethod(options) {
  options.icons = [];
  options.add = function (icons) {
    icons = [].concat(icons);
    const list = _flatInstanceProperty(icons).call(icons);
    list.forEach(icon => {
      let iconData;
      if (typeof icon === 'string') {
        iconData = JSON.parse(icon);
      } else {
        iconData = icon;
      }
      const index = this.icons.findIndex(item => item.name === iconData.name);
      if (index === -1) {
        this.icons.push(iconData);
      }
      if (iconData.dark) {
        this.icons.push(iconData.dark);
      }
    });
  };
  options.install = app => {
    const {
      name
    } = options;
    app.component(name, options);
  };
  return options;
};
export default withCustomMethod(UiIcon);